import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Property from '../atoms/Property';
import { byProperty } from '../../lib/utils';
import styles from '../../styles/components/molecules/PropsListed.module.scss';
import { Venue } from '../../graphql/types';
import { cloudflareLoader } from '../atoms/Img';

interface RestaurantListedProps {
  className?: string;
  tiny?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  hero?: boolean;
  data: Partial<Venue>;
}

export default function RestaurantListed(props: RestaurantListedProps) {
  const { itemListed } = styles;
  const { data: venue, className } = props;
  const {
    slug,
    cat,
    name,
    country,
    state,
    city,
    status,
    images,
    rating,
    rates,
    specs,
  } = venue as any;
  const itemType =
    status === 'promoted'
      ? 'large'
      : status === 'approved'
      ? 'medium'
      : 'small';
  const thumbnail = images ? images[0] : null; // "/assets/thumbs/carousel_0001_venues_frankfurt.jpg";
  const locationStr =
    status === 'promoted'
      ? `${country}, ${!!state ? state + ',' : ''} ${city}`
      : `${city}, ${country}`;
  const statusStr =
    status === 'promoted'
      ? 'Promoted'
      : status === 'approved'
      ? 'Approved by owner'
      : '';
  const classes = clsx(itemListed, styles[itemType], className);
  const href = `/venue/${venue.slug}`;

  return (
    <div className={classes}>
      <Link href={href}>
        <a>
          <figure>
            <figcaption>
              <p>
                <b>{name}</b>
                <br />
                {statusStr && <Property icon={status} label={statusStr} />}
              </p>
              <ul>
                <li>
                  {statusStr && <Property icon={status} label={statusStr} />}
                </li>
                {specs.map((el: any, i: number) => (
                  <li key={i}>
                    <Property icon={el.id} value={el.value} unit={el.unit} />
                  </li>
                ))}
                <li>
                  <Property icon={'rating'} label="0" unit={`(${0})`} />
                </li>
              </ul>
            </figcaption>

            <div>
              {thumbnail ? (
                <Image
                  loader={cloudflareLoader}
                  src={thumbnail}
                  alt={'an image'}
                  layout="fill"
                  objectFit="cover"
                />
              ) : (
                <Icon name="venue" />
              )}
            </div>
          </figure>
        </a>
      </Link>
    </div>
  );
}
